// Orders is temporarily hidden for every account. Keep the access helper as the
// single switch so the underlying data and implementation remain untouched.
export const isOrdersEnabledForAccount = () => false;
